import { from } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BROADCAST_UPDATE_SOURCE } from '@shoflo/studio-redux/actions/types';
import { getBroadcastRouteMatch } from 'actions/utils';
import {
  BROADCAST_PROGRAM_CHANGE,
  SOURCE_TOGGLE
} from '@shoflo/studio-redux/constants/SocketEvents';
import { setSourceUpdateStatus } from '@shoflo/studio-redux/actions';
import {
  UPDATE_FAILED,
  UPDATE_SUCCESSFUL
} from '@shoflo/studio-redux/constants/SourceUpdateStatuses';

export default function sourceUpdated(socket) {
  return store => next => async action => {
    const targetActions = [
      `${BROADCAST_UPDATE_SOURCE}_SUCCESS`,
      `${BROADCAST_UPDATE_SOURCE}_FAILURE`
    ];

    from([action])
      .pipe(filter($action => targetActions.includes($action.type)))
      .subscribe($action => {
        const { type, payload } = $action;
        const sourceId = payload._id;

        switch (type) {
          case `${BROADCAST_UPDATE_SOURCE}_SUCCESS`: {
            const { meeting, program } = store.getState();
            const {
              params: { broadcastId }
            } = getBroadcastRouteMatch(store.getState);

            const attendeeId = meeting?.attendeeResponse?.Attendee?.AttendeeId;

            socket.emit(SOURCE_TOGGLE, {
              broadcastId,
              notifyingDirector: attendeeId,
              source: payload
            });

            socket.emit(BROADCAST_PROGRAM_CHANGE, {
              broadcastId,
              notifyingDirector: attendeeId,
              program
            });

            store.dispatch(setSourceUpdateStatus(sourceId, UPDATE_SUCCESSFUL));
            break;
          }
          case `${BROADCAST_UPDATE_SOURCE}_FAILURE`: {
            store.dispatch(setSourceUpdateStatus(sourceId, UPDATE_FAILED));
            break;
          }
        }
      });

    return next(action);
  };
}
